import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/Home.vue";
import Survey from "../views/survey/Survey";
import ShopInfo from "../views/survey/ShopInfo";
import ProductSurvey from "../views/survey/ProductSurvey";
import CompetitorAnalyze from "../views/survey/CompetitorAnalyze";
import SurveyDetails from "../views/survey/SurveyDetails";
import History from "../views/History";
import Questionnaire from "../views/survey/Questionnaire";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    children: [
      {
        path: "/history",
        name: "History",
        component: History,
      },
      {
        path: "/about",
        name: "About",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/About.vue"),
      },
    ],
  },
  {
    path: "/survey",
    name: "Survey",
    component: Survey,
    children: [
      {
        path: "shop-info",
        name: "ShopInfo",
        component: ShopInfo,
      },
      {
        path: "product-survey",
        name: "ProductSurvey",
        component: ProductSurvey,
      },
      {
        path: "competitor-analyze",
        name: "CompetitorAnalyze",
        component: CompetitorAnalyze,
      },
      {
        path: "details",
        name: "SurveyDetails",
        component: SurveyDetails,
      },
      {
        path: "questionnaire",
        name: "Questionnaire",
        component: Questionnaire,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
